export default [
  {
    path: "/queues",
    name: "queues",
    redirect: "/operations/queues",
  },
];
